import React, { Fragment, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useTheme } from '@material-ui/core/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Spinner from 'react-spinkit';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import Loading from './layout/Loading';
import PageContainer from './layout/PageContainer';
import { GET_DOWNLOAD_FILE_TOKEN, GET_MY_FILES } from '../gql/files';
import Note from './layout/Note';
import PagePaper from './layout/PagePaper';

const File = ({ file }) => {
  const theme = useTheme();
  const serverUri = process.env.REACT_APP_SERVER_URI;
  const [showLoading, setShowLoading] = useState(false);
  const [getDownloadFileToken, { loading, error }] = useMutation(
    GET_DOWNLOAD_FILE_TOKEN,
    {
      fetchPolicy: 'no-cache',
      onCompleted({ downloadFileToken }) {
        window.open(
          `${serverUri}/download?token=${downloadFileToken}`,
          '_target'
        );
        setShowLoading(false);
      },
    }
  );

  return (
    <>
      <ListItem
        button
        onClick={() => {
          getDownloadFileToken({
            variables: { id: file.id, displayName: file.category.displayName },
          });
          if (loading) setShowLoading(true);
          if (error) {
            console.log(error);
          }
        }}
      >
        <ListItemIcon>
          <AttachFileIcon />
        </ListItemIcon>
        <ListItemText
          primary={file.category.displayName}
          secondary={`Uploaded: ${moment(file.updatedAt).fromNow()}`}
        />
        {showLoading ? (
          <Spinner name="line-scale" color={theme.palette.primary.main} />
        ) : (
          ''
        )}
      </ListItem>
      <Divider variant="middle" component="li" />
    </>
  );
};
const Home = () => {
  const { loading, error, data } = useQuery(GET_MY_FILES, {
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loading />;

  if (error) {
    return `Error! ${error}`;
  }
  const {
    me: { files },
  } = data;
  return (
    <PageContainer title="Your Certificates">
      {files.length > 0 ? (
        <>
          <Note>Click to download</Note>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PagePaper>
                <List>
                  {files.map((file) => (
                    <File key={file.id} file={file} />
                  ))}
                </List>
              </PagePaper>
            </Grid>
          </Grid>
        </>
      ) : (
        <Note>You do not have any certificate currently</Note>
      )}
    </PageContainer>
  );
};

File.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string.isRequired,
    category: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
    }),
    updatedAt: PropTypes.instanceOf(Date).isRequired,
  }).isRequired,
};

export default Home;
